module.exports = __webpack_public_path__ + "img/placeholder.4b0ff2f3.svg";